/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from "@emotion/react";
import { Breadcrumb } from "components/atoms/Breadcrumb";
import React from "react";
import { ScrollLock } from "ui/ScrollLock";

import { DetailedSearchModal } from "./components/DetailedSearchModal";
import { SearchForm } from "./components/SearchForm";
import { contentsWrapperStyle } from "./styles";
import { useThis } from "./useThis";

import type { Props } from "./props";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

export const Search: FcWithoutChildren<Props> = (props) => {
  const {
    breadcrumbPaths,
    eventResultCount,
    genreConditions,
    getContents,
    hasSearched,
    handleChangeKeyword,
    isDetailSearchEnabled,
    isModalOpen,
    keyword,
    setModalOpen,
  } = useThis(props);

  return (
    <div
      css={css`
        background-color: ${hasSearched ? "white" : "transparent"};
      `}
    >
      <Breadcrumb paths={breadcrumbPaths} />
      <SearchForm
        keyword={keyword}
        onChangeKeyword={handleChangeKeyword}
        setModalOpen={setModalOpen}
      />
      <div css={contentsWrapperStyle}>
        {getContents()}
        {isModalOpen && (
          <>
            <ScrollLock />
            <DetailedSearchModal
              genreConditions={genreConditions}
              isDetailSearchEnabled={isDetailSearchEnabled}
              keyword={keyword}
              onChangeKeyword={handleChangeKeyword}
              onClose={() => {
                setModalOpen(false);
              }}
              resultCount={eventResultCount}
            />
          </>
        )}
      </div>
    </div>
  );
};
